import ReactGA from "react-ga4";

// Initialize GA4 with your measurement ID
export const initGA = (measurementId) => {
  ReactGA.initialize(measurementId);
};

// Track page views
export const trackPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

// Track custom events
export const trackEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};

// Track timing events
export const trackTiming = (category, variable, value) => {
  ReactGA.send({
    hitType: "timing",
    timingCategory: category,
    timingVar: variable,
    timingValue: value,
  });
};
